(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/retail-cover-image/assets/javascripts/retail-cover-image.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/retail-cover-image/assets/javascripts/retail-cover-image.js');
"use strict";


const {
  getCoverImageUrl,
  getDefaultCoverImageUrl
} = svs.components.marketplaceRetailAdmin.helpers.getCoverImageUrl;
const {
  Image
} = svs.content.image_v2;
const RetailCoverImage = _ref => {
  let {
    image,
    classname = ''
  } = _ref;
  const imageUrl = getCoverImageUrl(image);
  const imgObject = {
    noscriptUrl: imageUrl,
    originalImage: true
  };
  return React.createElement("div", {
    className: classname,
    id: "retail-cover-image"
  }, React.createElement(Image, {
    className: classname,
    fallbackImage: getDefaultCoverImageUrl(),
    image: imgObject,
    style: {
      display: 'block'
    }
  }));
};
setGlobal('svs.components.marketplaceRetailAdmin.retailCoverImage.RetailCoverImage', {
  RetailCoverImage
});

 })(window);